import React from 'react';
import TopNav from './TopNav';
import Footer from './Footer';
import useSEO from '../hooks/useSEO';

const BOOKING_URL = 'https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ1XYIg0DhG3Nqdxt8YFz-OfIFFULR4_0LPI3RgD3JhjflJ42aOeYcAtXAwJ8Ou7FYG5D7bQ7gEJ?gv=true';

const BookingPage = () => {
  useSEO({
    title: 'Book a Demo | Veydra',
    description: 'Schedule a conversation with the Veydra team using our live calendar.'
  });

  return (
    <div className="min-h-screen bg-white">
      <TopNav />

      <main className="max-w-6xl mx-auto px-6 md:px-8 py-12 md:py-16">
        <div className="text-center mb-8 md:mb-10">
          <p className="text-sm font-medium text-gray-500 uppercase tracking-wider mb-3">
            Book a Demo
          </p>
          <h1 className="text-3xl md:text-4xl font-medium text-gray-900 mb-4 tracking-tight">
            Schedule a conversation
          </h1>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Pick a time that works for you. We will walk through your use case, answer questions, and map next steps.
          </p>
        </div>

        <section className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm">
          <iframe
            src={BOOKING_URL}
            style={{ border: 0 }}
            width="100%"
            className="h-[1700px] md:h-[1300px]"
            frameBorder="0"
            title="Veydra Booking Calendar"
          />
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default BookingPage;
